import {
  Component,
  Input,
  Output,
  EventEmitter,
  ElementRef,
  OnDestroy,
} from "@angular/core";

@Component({
  selector: "app-training-verify-dropdown",
  templateUrl: "./training-verify-dropdown.component.html",
  styleUrls: ["./training-verify-dropdown.component.scss"],
})
export class TrainingVerifyDropdownComponent implements OnDestroy {
  @Input() traineeId!: number;
  @Input() topicKey!: string;
  @Input() currentScore!: number;
  @Input() isSaving!: boolean;
  @Input() options: any[] = [];
  @Input() disabled: boolean = false;

  @Input() set buttonClass(value: string) {
    this._buttonClass = value;
  }
  get buttonClass(): string {
    return this._buttonClass;
  }
  private _buttonClass = "";

  @Output() scoreChange = new EventEmitter<number>();

  isDropdownOpen = false;

  private static openDropdown: TrainingVerifyDropdownComponent | null = null;

  constructor(private el: ElementRef) {
    document.addEventListener("click", this.onDocumentClick);
  }

  toggleDropdown(): void {
    if (this.disabled) return; // Prevent opening if disabled
    
    if (
      TrainingVerifyDropdownComponent.openDropdown &&
      TrainingVerifyDropdownComponent.openDropdown !== this
    ) {
      TrainingVerifyDropdownComponent.openDropdown.closeDropdown();
    }

    this.isDropdownOpen = !this.isDropdownOpen;

    TrainingVerifyDropdownComponent.openDropdown = this.isDropdownOpen
      ? this
      : null;
  }

  selectScore(selectedOptionId: number): void {
    if (this.currentScore !== selectedOptionId && !this.isSaving) {
      this.scoreChange.emit(selectedOptionId);
    }
    this.closeDropdown();
  }

  closeDropdown(): void {
    this.isDropdownOpen = false;
    if (TrainingVerifyDropdownComponent.openDropdown === this) {
      TrainingVerifyDropdownComponent.openDropdown = null;
    }
  }

  onDocumentClick = (event: Event) => {
    if (!this.el.nativeElement.contains(event.target)) {
      this.closeDropdown();
    }
  };

  ngOnDestroy(): void {
    document.removeEventListener("click", this.onDocumentClick);
  }
}
